import React from "react";
import ReactTable from 'react-table-v6'
import '../../assets/css/Table.css'
import moment from 'moment';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { withStyles } from '@material-ui/core/styles';
import GridContainer from "../Grid/GridContainer.jsx";
import GridItem from "../Grid/GridItem.jsx";
import Card from "../Card/Card.jsx";
import CardBody from "../Card/CardBody.jsx";
import CardHeader from "../Card/CardHeader.jsx";
import { cardTitle } from "../../assets/jss/material-dashboard-pro-react.jsx";
import ExportTo from '../Common/ExportTo'
import CustomDialog from '../Common/CustomDialog'

const styles = theme => ({
    margin: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1)
    },
    cardIconTitle: {
        ...cardTitle,
        marginTop: "6px",
        marginBottom: "0px"
    },
    
});

class ReactTables extends React.Component {
    state = {
        openDialogWhenNoData: false
    }

    handleLink = val => {
        window.open(val);
    }

    exportPDF = () => {
        const { openDialogWhenNoData } = this.state;
        const { arrLinks } = this.props;
        if(arrLinks.length === 0){
            return this.setState({ openDialogWhenNoData: !openDialogWhenNoData })
        }
        else {
            const unit = "pt";
            const size = "A4";
            const orientation = "landscape";

            const marginLeft = 20;
            const doc = new jsPDF(orientation, unit, size);

            doc.setFontSize(15);

            const title = this.props.showingAttachments ? "My Attachments" : "My Order Updates";
            const headers = [["Links" ]];

            const data = arrLinks.map((prop, key) => ([
                prop.link,
            ]))

            let content = {
            startY: 50,
            head: headers,
            body: data
            };

            doc.text(title, marginLeft, 40);
            doc.autoTable(content);
            doc.save(`${this.props.showingAttachments? 'attachments' : 'order_updates'}_${moment().format('LLL')}`)
        }
    }

    exportExcel = () => {
        const { openDialogWhenNoData } = this.state;
        const { arrLinks } = this.props;
        if(arrLinks.length === 0){
          this.setState({ openDialogWhenNoData: !openDialogWhenNoData });
          return false
        }
        return true
    }

    render() {
        const { openDialogWhenNoData } = this.state;
        const { classes, arrLinks, loading, showingAttachments } = this.props;

        const dataExcel = arrLinks.map((prop, key) => {
            return {
                "Links": prop.link,
            };
        })
        
        return (
            <GridContainer style={{width:'83vw'}}>
                <GridItem xs={12}>
                    <Card>
                    <CardHeader color="rose" icon>
                            <div className={classes.cardIconTitle}>
                                <ExportTo 
                                    fileName={'attachments'}
                                    exportPDF={this.exportPDF}
                                    dataExcel={dataExcel}
                                    exportExcel={this.exportExcel}
                                />
                            </div>
                        </CardHeader>
                        <CardBody>
                            <ReactTable
                               loading={loading}
                               NoDataComponent={() => !loading && <p style={{textAlign: "center"}}>No {showingAttachments ? "Attachments" : "Order Updates"} available</p>}
                                data={arrLinks}
                                filterable  
                                columns={[
                                    {
                                        Header: "Links",
                                        accessor: "link",
                                        Cell : ({ row }) => (
                                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                                            <a
                                                role="button"
                                                style={{color: "green"}} 
                                                onClick={() => this.handleLink(row._original.link)}
                                            >
                                                {row._original.link}
                                            </a>
                                        ),
                                        headerStyle: { textAlign: 'left'}
                                    },
                                ]}
                                sortable={false}
                                style={{ width: '99%', border: 'none', whiteSpace: 'unset', marginLeft: 'auto', marginRight: 'auto' }}
                                defaultPageSize={10}
                                minRows={0}
                                showPaginationTop
                                showPaginationBottom={false}
                                className="-striped -highlight"
                                getTrGroupProps={() => {
                                    return {
                                        style: {
                                            borderBottom: "1px solid #d6d6d6",
                                        }
                                    }
                                }}
                                getPaginationProps={() => { return { style: { boxShadow: 'none', border: 'none', } } }}
                            />
                        </CardBody>
                    </Card>
                </GridItem>
                <CustomDialog 
                    openDialog={openDialogWhenNoData}
                    closeDialog={() => this.setState({ openDialogWhenNoData: !openDialogWhenNoData })}
                />
            </GridContainer>
        );
    }
}

export default withStyles(styles)(ReactTables);